export const datatable = {
  datatable: {
    colorScheme: {
      light: {
        header: {
          background: '{slate.50}',
          cell: {
            selectedColor: 'var(--p-primary-color)',
            selectedBackground: '{slate.50}',
            background: '{slate.50}',
            color: 'var(--p-text-color)',
            hoverColor: 'var(--p-text-color)',
            hoverBackground: '{slate.100}',
          },
        },
        row: {
          hoverColor: 'var(--p-text-color)',
          hoverBackground: '{slate.100}',
        },
      },
    },
  },
};
